import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Textarea, Dialog } from "@activecollab/components";
import { Formik, Form, Field } from "formik";
import PropTypes from "prop-types";
import { stopwatchEdit } from "~/store/actions/actions.stopwatches";

const StopwatchDescriptionForm = ({ id, open, description, onClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Formik
        initialValues={{ description }}
        onSubmit={({ description }) => {
          dispatch(stopwatchEdit(id, { description })).then(() => {
            onClose();
          });
        }}
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <Dialog.Title>{t("Update Description")}</Dialog.Title>
            <Dialog.ContentDivider />
            <Dialog.Content>
              <Field name="description">
                {({ field }) => {
                  return (
                    <Textarea
                      autoFocus
                      className="tw-w-full"
                      {...field}
                    />
                  );
                }}
              </Field>
            </Dialog.Content>
            <Dialog.ContentDivider />
            <Dialog.Actions>
              <Button
                type="submit"
                disabled={isSubmitting || !dirty}
                variant="primary"
                className="tw-mr-3"
              >
                {t("Update")}
              </Button>
              <Button
                type="button"
                onClick={onClose}
                variant="secondary"
                disabled={isSubmitting}
              >
                {t("Cancel")}
              </Button>
            </Dialog.Actions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

StopwatchDescriptionForm.propTypes = {
  id: PropTypes.number,
  open: PropTypes.bool,
  description: PropTypes.string,
  onClose: PropTypes.func,
};

StopwatchDescriptionForm.defaultProps = {
  open: false,
};

StopwatchDescriptionForm.displayName = "StopwatchDescriptionForm";

export default StopwatchDescriptionForm;
